// extracted by mini-css-extract-plugin
export default {"wrapper":"database-info_wrapper__7a6LT","boxSqlite":"database-info_boxSqlite__PY3+G","boxButton":"database-info_boxButton__sdDvN"};